import {
  AfterContentInit,
  ChangeDetectorRef,
  Directive,
  Host,
  HostListener,
  Input,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[ngbNav][aaTabRoute]',
  standalone: false,
})
export class TabRouteDirective implements AfterContentInit, OnDestroy {
  @Input() id: string;

  private subscriptions: Subscription[] = [
    this.tabset.navChange.subscribe(($event: NgbNavChangeEvent) => this.onTabChange($event)),
  ];

  constructor(
    @Host() private tabset: NgbNav,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
  ) {}

  ngAfterContentInit() {
    setTimeout(() => {
      this.onHashChange();

      // Changing things during ngAfterContentInit causes ExpressionChangedAfterItHasBeenCheckedError
      // Marking the component as changed prevents the error occurring in debug
      // and makes sure this change is detected in prod
      this.cd.detectChanges();
    });

    this.subscriptions.push(
      this.router.events
        .pipe(filter((ev: any): ev is NavigationEnd => ev instanceof NavigationEnd))
        .subscribe(() => this.onHashChange()),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  @HostListener('window:hashchange', ['$event'])
  onHashChange($event?: HashChangeEvent) {
    const hash = location.hash && location.hash.substring(1).split(/\?/)[0];
    if (hash) {
      const tab = this.tabset.items.find(item => item.id === hash);
      if (tab) {
        if (this.tabset.activeId !== hash) {
          this.tabset.select(hash);
        }
        if ($event) {
          $event.preventDefault();
        }
      }
    }
  }

  onTabChange($event: NgbNavChangeEvent) {
    const hash = location.hash && location.hash.substring(1).split('?')[0];
    const { nextId } = $event;

    if (hash !== nextId) {
      // Delaying navigation gives TabHasChanges a chance to prevent the event
      const preventDefault = $event.preventDefault;
      const delayedNavigation = setTimeout(() =>
        this.router.navigate(['.'], { fragment: nextId, relativeTo: this.route }),
      );

      $event.preventDefault = () => {
        clearTimeout(delayedNavigation);
        preventDefault();
      };
    }
  }
}
